import React, { useState } from 'react'
import styled from '@emotion/styled'
import { CloseOutlined } from '@ant-design/icons'

const DevInfoBanner = () => {
  const [showDevInfo, setShowDevInfo] = useState<boolean>(true)
  const gitBranchName = process.env.REACT_APP_GIT_BRANCH

  return (
    <>
      {showDevInfo && gitBranchName && (
        <DevInfoContainer data-testid='dev-info-banner'>
          <h3>{gitBranchName}</h3>
          <CloseButtonContainer
            data-testid='close-button'
            onClick={() => setShowDevInfo(false)}
          >
            <CloseOutlined />
          </CloseButtonContainer>
        </DevInfoContainer>
      )}
    </>
  )
}

const DevInfoContainer = styled.div(() => ({
  position: 'relative',
  zIndex: 5001,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '35px',
  backgroundColor: '#cc4d53',
  '& h3': {
    marginLeft: 'auto',
    fontWeight: 'normal',
    color: 'white'
  }
}))

const CloseButtonContainer = styled.div(() => ({
  marginLeft: 'auto',
  marginRight: '10px',
  order: 2,
  cursor: 'pointer',
  svg: {
    height: '16px',
    width: '16px',
    fill: 'white'
  }
}))

export default DevInfoBanner
